module.exports = __webpack_public_path__ + "static/4-47be36b7bec9dc138f046bfc6db27321.jpg";